<template>
  <div class="baniere">
    <div class="md:mt-16">
      <div class="w-full flex flex-wrap">
        <services
          class="service"
          icon="ic_user"
          label="Acquisition de nouvelles niches"
          data-aos="fade-right"
          data-aos-duration="2000"
        />

        <services
          class="service md:ml-12 ml-6"
          icon="ic_flech"
          label="Automatisation de la production"
          data-aos="fade-up"
          data-aos-duration="2000"
        />

        <services
          class="service md:ml-12"
          icon="ic_wallet"
          label="Flexibilité des moyens de paiements"
          data-aos="fade-left"
          data-aos-duration="2000"
        />

        <services
          class="service md:ml-0 ml-6"
          icon="ic_link"
          label="Traitement collaboratif des sinistres"
          data-aos="fade-right"
          data-aos-duration="2000"
        />

        <services
          class="service md:ml-12"
          icon="ic_itineraire"
          label="Automatisation des remboursement de sinistres"
          data-aos="fade-up"
          data-aos-duration="2000"
        />

        <services
          class="service md:ml-12 ml-6"
          icon="ic_db"
          label="Sécurisation des données des clients et d’entreprise"
          data-aos="fade-left"
          data-aos-duration="2000"
        />

        <services
          class="service"
          icon="ic_person"
          label="Lutte contre la fraude à l’assurance"
          data-aos="fade-up"
          data-aos-duration="2000"
        />

        <services
          class="service md:ml-12 ml-6"
          icon="ic_message"
          label="Service client très réactif"
          data-aos="fade-up"
          data-aos-duration="2000"
        />

        <services
          class="service md:ml-12"
          icon="ic_api"
          label="API publiques et interopérabilités"
          data-aos="fade-up"
          data-aos-duration="2000"
        />
      </div>
    </div>
  </div>
</template>

<script>
import services from '@/components/cedo/assurance/services'

export default {
  name: 'Index',
  components: {
    services
  },
  props: {
  },
  data () {
    return {

    }
  },
  created () {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
 .baniere{
   height: auto ;
   background-color: $white;
   position: relative;
   padding-left: $padding-l;
   padding-right: $padding-r;
 }
  .service{
    width: 30%;
    margin-bottom: 70px;
  }
  @media screen and (max-width: 600px){
    .baniere{
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 10px;
    }
    .detail{
      font-size: 18px;
    }
    .service{
      width: 46%;
      margin-bottom: 30px;
    }
  }
  @media screen and (min-width: 701px) and (max-width: 1024px){
    .baniere{
      padding-left: $padding-l-1024;
      padding-right: $padding-r-1024;
    }
    .titre{
      font-size: 30px;
    }

    .service{
      width: 29.5%;
      margin-bottom: 30px;
    }
  }
</style>
